// client/src/services/inboxAutomationApi.js
// Inbox automation (Roadmap Phase 4): saved replies, keyword auto-reply rules,
// the activity log and the kill switch. Server: routes/inboxAutomationRoutes.js
// at /api/inbox-automation/:tenant (checked against the session).

const BASE_URL = process.env.REACT_APP_BASE_URL?.replace(/\/$/, '') || '';

async function request(method, url, body) {
  const res = await fetch(`${BASE_URL}${url}`, {
    method,
    credentials: 'include',
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : {},
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || data.error || `${res.status} ${res.statusText}`);
    err.response = { status: res.status, data };
    throw err;
  }
  return data;
}

const base = (tenantId) => `/api/inbox-automation/${Number(tenantId)}`;

export function errorText(err, fallback) {
  return err?.response?.data?.message || err?.response?.data?.error || fallback;
}

/** { ready, paused, channels: [{ key, platform, kind, connected, pendingApproval, privateReply }], limits } */
export const getAutomationSettings = (tenantId) => request('GET', `${base(tenantId)}/settings`);
export const setAutomationPaused = (tenantId, paused) => request('PUT', `${base(tenantId)}/settings`, { paused });

export const listSavedReplies = (tenantId) => request('GET', `${base(tenantId)}/saved-replies`);
export const createSavedReply = (tenantId, body) => request('POST', `${base(tenantId)}/saved-replies`, body);
export const updateSavedReply = (tenantId, id, body) => request('PUT', `${base(tenantId)}/saved-replies/${Number(id)}`, body);
export const deleteSavedReply = (tenantId, id) => request('DELETE', `${base(tenantId)}/saved-replies/${Number(id)}`);
export const markSavedReplyUsed = (tenantId, id) => request('POST', `${base(tenantId)}/saved-replies/${Number(id)}/used`);

export const listRules = (tenantId) => request('GET', `${base(tenantId)}/rules`);
export const createRule = (tenantId, body) => request('POST', `${base(tenantId)}/rules`, body);
export const updateRule = (tenantId, id, body) => request('PUT', `${base(tenantId)}/rules/${Number(id)}`, body);
export const deleteRule = (tenantId, id) => request('DELETE', `${base(tenantId)}/rules/${Number(id)}`);
export const testRules = (tenantId, body) => request('POST', `${base(tenantId)}/rules/test`, body);

export const getActivityLog = (tenantId, { before = null, status = '' } = {}) =>
  request('GET', `${base(tenantId)}/log?limit=50${before ? `&before=${Number(before)}` : ''}${status ? `&status=${encodeURIComponent(status)}` : ''}`);

/** Replace {name} with the person's name (or "there"). */
export function fillName(text, name) {
  const n = String(name || '').trim().replace(/^@/, '');
  return String(text || '').replace(/\{name\}/g, n || 'there');
}
